export { getSections, availableLocales, Locale } from './SideNav/menu-sections';
